import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageHeader from '../../../shared/page-header/components/page-header';
import RenderIf from '../../../shared/render-if/components/render-if';
import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import EmptyState from '../../../shared/empty-state/components/empty-state';
import PaymentMethodModal from './payment-method-modal';
import AddPaymentMethodModal from './add-payment-method-modal';
import PaymentMethodsTable from './payment-methods-table';
import PaymentMethodDetailsModal from './payment-method-details-modal';
import { getUserPaymentMethods, togglePaymentMethodModal, getPaymentMethodTypes } from '../actions/payment-method-actions';

class PaymentMethods extends Component {
  componentDidMount() {
    const { getUserPaymentMethods } = this.props;

    getUserPaymentMethods();
  }

  showPaymentMethodModal() {
    const { togglePaymentMethodModal, getPaymentMethodTypes } = this.props;

    getPaymentMethodTypes(true);
    togglePaymentMethodModal(true);
  }

  render() {
    const { paymentMethods, paymentMethodTypes, showPaymentMethodModal, showAddPaymentMethodModal, selectedPaymentMethodType, selectedPaymentMethod, httpInProgress } = this.props;

    return (
      <div className="payment-methods-container">
        <RenderIf if={showPaymentMethodModal && paymentMethodTypes && paymentMethodTypes.length > 0}>
          <PaymentMethodModal />
        </RenderIf>
        <RenderIf if={showAddPaymentMethodModal && selectedPaymentMethodType && paymentMethodTypes && paymentMethodTypes.length > 0}>
          <AddPaymentMethodModal />
        </RenderIf>
        <RenderIf if={selectedPaymentMethod}>
          <PaymentMethodDetailsModal />
        </RenderIf>
        <PageHeader
          title={'PAYMENT_METHODS.TITLE'}
          actionBtn={'PAYMENT_METHODS.ADD_METHOD_BTN'}
          displayBtn={paymentMethods && paymentMethods.length > 0}
          btnCallback={this.showPaymentMethodModal.bind(this)}
        />
        <RenderIf if={httpInProgress}>
          <DefaultLoader />
        </RenderIf>
        <RenderIf if={!httpInProgress && paymentMethods && paymentMethods.length === 0}>
          <EmptyState title={'PAYMENT_METHODS.NO_PAYMENT_METHODS_MESSAGE'} actionButtonLabel={'PAYMENT_METHODS.ADD_METHOD_BTN'} callback={this.showPaymentMethodModal.bind(this)} />
        </RenderIf>
        <RenderIf if={!httpInProgress && paymentMethods && paymentMethods.length > 0}>
          <PaymentMethodsTable />
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  paymentMethods: state.paymentMethodsReducer.paymentMethods,
  paymentMethodTypes: state.paymentMethodsReducer.paymentMethodTypes,
  showPaymentMethodModal: state.paymentMethodsReducer.showPaymentMethodModal,
  showAddPaymentMethodModal: state.paymentMethodsReducer.showAddPaymentMethodModal,
  selectedPaymentMethodType: state.paymentMethodsReducer.selectedPaymentMethodType,
  selectedPaymentMethod: state.paymentMethodsReducer.selectedPaymentMethod,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
});

const mapDispatchToProps = dispatch => ({
  getUserPaymentMethods: (status, provider, type) => {
    dispatch(getUserPaymentMethods(status, provider, type));
  },
  togglePaymentMethodModal: show => {
    dispatch(togglePaymentMethodModal(show));
  },
  getPaymentMethodTypes: active => {
    dispatch(getPaymentMethodTypes(active));
  },
});

PaymentMethods.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethods);



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/components/payment-methods.js